import NodeWebSocket from "ws";
import { ITransport, ITransportEventMap } from "./ITransport";

// const WebSocket = globalThis.WebSocket || NodeWebSocket;

export class MPSocketTransport implements ITransport {
    ws: WebSocket | NodeWebSocket;
    protocols?: string | string[];

    constructor(public events: ITransportEventMap) {}

    public send(data: ArrayBuffer | Array<number>): void {
        if (data instanceof ArrayBuffer) {
            this.ws.send(data);
        } else if (Array.isArray(data)) {
            this.ws.send(new Uint8Array(data).buffer);
        }
    }

    public connect(url: string) {
        // this.ws = new WebSocket(url, this.protocols);

        const socket = wx.connectSocket({
            url,
            // header: {
            //     'content-type': 'application/json'
            // },
            protocols: this.protocols,
            // method: 'GET'
            success: (res) => {},
        });

        socket.onMessage((msg) => {
            console.log("msg", msg);
            this.events.onmessage(msg);
        });

        socket.onClose((msg) => {
            console.log("close", msg);
            this.events.onclose(msg);
        });

        // socket.onOpen((msg) => {
        //     console.log("open", msg);
        //     this.events.onopen(msg);
        // });

        socket.onError((msg) => {
            console.log("error", msg);
            this.events.onerror(msg);
        });

        console.log(this.ws);

        // this.ws.binaryType = "arraybuffer";
        // this.ws.onopen = this.events.onopen;
        // this.ws.onmessage = this.events.onmessage;
        // this.ws.onclose = this.events.onclose;
        // this.ws.onerror = this.events.onerror;
    }

    public close(code?: number, reason?: string) {
        console.log("关闭连接");

        this.ws.close(code, reason);
    }
}
